import { useCallback } from 'react';
import { CallQualityDrilldownScreen as CallQualityDrilldown } from '@frontend/phone-panels';
import { useCallInsightPanelShallowStore } from '../../hooks/use-call-insight-panel-store';
import { ScreenBaseProps, ScreenType } from '../../types';
import { ScreenLayout } from '../screen-layout';

export type CallInsightScreenProps = ScreenBaseProps<ScreenType.CALL_QUALITY_DRILLDOWN>;

export const CallQualityDrilldownScreen = ({
  data,
  panelStyles,
  source,
  onClose,
  setScreen,
}: CallInsightScreenProps) => {
  const { closeContext } = useCallInsightPanelShallowStore('contexts', 'closeContext');

  const handleClose = useCallback(() => {
    closeContext({ source });
    !!onClose && onClose();
  }, [closeContext, onClose, source]);

  if (!data) {
    return null;
  }

  return (
    <ScreenLayout
      panelStyles={panelStyles}
      onClose={handleClose}
      header={CallQualityDrilldown.Header({
        data,
        onBack: () => setScreen({ screenType: ScreenType.CALL_QUALITY }),
      })}
      content={<CallQualityDrilldown.Content data={data} />}
    />
  );
};
